import React from 'react';
import {
  FormPageMainContent,
  FormPageMainContentProps,
} from '../FormPageMainContent';

export interface EntityPageMainContentProps extends FormPageMainContentProps {}

export function EntityPageMainContent(props: EntityPageMainContentProps) {
  return <FormPageMainContent {...props} />;
}

EntityPageMainContent.displayName = 'EntityPageMainContent';
